import React from 'react';
import { useQuery } from 'react-apollo';

import { useAuthService } from '@/contexts/authService';
import {
  UserQueryPrivate,
  UserQueryPublicBasic,
} from '../../state/services/gql/user';

import UserMenu from '../../components/UserMenu';

export default (props) => {
  const authService = useAuthService();
  const Query = authService.loggedIn()
    ? UserQueryPrivate
    : UserQueryPublicBasic;
  const query = useQuery(Query, {
    variables: { id: authService.getUserCookie() },
    skip: !authService.getUserCookie(),
  });
  const { data } = query;

  return <UserMenu profile={data?.profile} {...props} />;
};
